import { render } from "./NotFoundComponent.vue?vue&type=template&id=ce4c3ccc"
const script = {}
script.render = render

export default script